import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { appConstants } from '../common-service/const.model';
import { ToastrService } from 'ngx-toastr';
import { encryptionService } from '../../app/common-service/cedService';
import { SignupService } from '../common-service/signup.service';
import { UsrmgtService } from '../usermgt/services/usrmgt.service';
import { UidrService } from '../uidr/uidr.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ServerURLService } from '../common-service/serverURL.service';
import { EncrDecrService } from '../common-service/EncrDecrService';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-uidr-certificate',
  templateUrl: './uidr-certificate.component.html',
  styleUrls: ['./uidr-certificate.component.css']
})
export class UidrCertificateComponent implements OnInit {
  uidrCertForm: FormGroup;
  captchImage: any;
  errorMsgs: any;
  submitted = false;
  UidrDetails: any = {
    reasonOfRejection: '',
    isFrivolous: false
  };
  uidrDetailsId: any;
  UIDRQualificationList: any = [];
  UidrDetailsHistoryList: any = {};
  userEmail: any;

  constructor(public fb: FormBuilder, public constValues: appConstants, public toastr: ToastrService,
    public ced: encryptionService, public usrmgtService: UsrmgtService, public router: Router, 
    public uidrService: UidrService, public route: ActivatedRoute, public serverURL: ServerURLService, 
    public EncrDecr: EncrDecrService, public spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    // this.route.params.subscribe((params: Params) => this.uidrDetailsId = params.id);
    // this.uidrDetailsId = this.ced.decryptAesformString(this.uidrDetailsId, this.serverURL.secretKey);

    this.errorMsgs = this.constValues.errorMsgs;
    this.uidrCertForm = this.fb.group({
      emailId: ['', [Validators.required, Validators.email]],
      authCode: ['', Validators.required]
    });
    // this.GetUIDRDetails();
  }
  get f() { return this.uidrCertForm.controls; } // Controls

  submit() {
    this.submitted = true;
    if (this.uidrCertForm.valid) {
      const resetObj = {
        emailId: this.uidrCertForm.value.emailId,
        authCode: this.uidrCertForm.value.authCode,
        // uidrDetailsId: this.uidrDetailsId
      };
      this.spinner.show();
        this.uidrService.uidrCertificateAuthenticate(resetObj).subscribe((res: any) => {      
          if(res.response.respcode === "200") {
            this.GeneratedCertificate(res.uidrDetailsId);
          } else {
            this.toastr.error('Please Enter Valid Details', 'Error', {
              timeOut: 3000
            });
          }
          this.spinner.hide();
        }, error => {
          this.toastr.error('Enter Valid Details', 'Error', {
            timeOut: 3000
          });
          this.spinner.hide();
        });
    } else {
      this.toastr.error('Enter Valid Details', 'Error', {
        timeOut: 3000
      });   
    }
  }

  public GeneratedCertificate(uidrDetailsId : any) {
    this.spinner.show();
    this.uidrService.DownloadUIDRCertificate(uidrDetailsId).pipe().subscribe((result: any) => {
      this.spinner.hide();
      let file = new Blob([result], { type: 'application/pdf' });
      var fileURL = window.URL.createObjectURL(file);
      window.open(fileURL);
    }, error => {
      console.log(error);
    });
  }

  GetUIDRDetails() {
    this.route.params.subscribe(params => {
      this.uidrService.getUIDRDetails(this.uidrDetailsId).pipe().subscribe((result: any) => {
        
        this.UidrDetails = result;
        this.UIDRQualificationList = result.qualificationList;        
        this.uidrCertForm.patchValue({
          'emailId': result.email
        })
      }, error => {
        console.log(error);
      });
    });
  }

  GetUIDRQualification() {
    this.route.params.subscribe(params => {
      this.uidrService.getUIDRDetailsHistory(this.uidrDetailsId).pipe().subscribe((result: any) => {
        this.UidrDetailsHistoryList = result;
      },
        error => {
          console.log(error);
        });

    });
  }
  
}
